import React from 'react'
import {
  Paper,
  Tab,
  Tabs
} from '@mui/material'

export default function DataDirectorTabs({ sections, value = 0, onChange }) {
  const handleTabChange = (event, newValue) => {
    // Call the parent's onChange handler if provided
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Paper 
      sx={{ 
        width: '100%', 
        mb: 4,
        backgroundColor: '#F9E9D3'
      }}
    >
      <Tabs
        value={value}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {sections.map((section, index) => (
          <Tab 
            key={index} 
            label={section.title} 
            icon={section.icon} 
            iconPosition="start"
            disabled={!section.implemented}
          />
        ))}
      </Tabs>
    </Paper>
  );
}